// extracted by css-extract-rspack-plugin
export default {"panel":"PositionsTabPanel_panel__qitOT"};